import { assert } from '../lib/assert-sidecar'

export type EntityType =
  | 'monster'
  | 'tile'
  | 'particle'
  | 'particle-spawner'
  | 'tile-selector'
  | 'cursor'
  | 'dialog'
  | 'stevie-text'
  | 'button'
  | 'num-selector'
  | 'text-input'
  | 'path-highlight'
  | 'object'
  | 'health-bar'
  | 'tile-map-ship'
  | 'tile-ship'
  | 'starmap'
  | 'tile-starmap'
  | 'cargo'
  | 'machine'
  | 'machine-part'
  | 'job'
  | 'job-creator'
  | 'stack'
  | 'asteroid'
  | 'blueprint'
  | 'blueprint-part'
  | 'fullness-indicator'
  | 'progress-indicator'
  | 'build-selector'
  | 'stack-selector'
  | 'machine-placer'
  | 'machine-placer-part'
  | 'portrait'
  | 'death-punch-enemy'
  | 'echo'
  | 'missile'
  | 'mower-mower'
  | 'mower-tile'
  | 'mower-tilemap'
  | 'mower-rock'
  | 'mower-flower'
  | 'under-tilemap'
  | 'under-misc'
  | 'under-ui'
  | 'goat-misc'
  | 'voy-misc'

export interface IEntity {
  id: number
  idLoaded: number
  isDead: boolean
  eType: EntityType
}

export interface ICollidable {
  eTypeId: number
}

export interface IDeadish extends IEntity {
  isDying?: boolean
}

export interface IEntityWithPlayerNumber extends IEntity {
  playerNumber: number
}

// export interface ICollidableWithBody extends ICollidable {
//   body: planck.Body
// }

// export interface IEntityWithBody extends IEntity, ICollidableWithBody {}
// export function findByBody<T extends ICollidableWithBody>(
//   body: planck.Body,
//   objs: T[],
// ): T {
//   for (let i = 0; i < objs.length; i++) {
//     if (objs[i].body === body) {
//       return objs[i]
//     }
//   }
//   assert.shouldNotExecute('could not find body')
//   // return null
// }
// export function findByBodySafe<T extends ICollidableWithBody>(
//   body: planck.Body,
//   objs: T[],
// ): T | null {
//   for (let i = 0; i < objs.length; i++) {
//     if (objs[i].body === body) {
//       return objs[i]
//     }
//   }

//   return null
// }

export function genericGetData<T extends { type: string }>(
  label: string,
  dataMapType: { [key: string]: T } = {},
  type: string,
) {
  let d = dataMapType['' + type]
  assert.notNil(d, 'data does not exist', label, type)
  return d
}

export function genericRegisterData<T extends { type: string }>(
  label: string,
  data: Partial<T>,
  _default: T,
  dataList: Array<T>,
  dataMapType: { [key: string]: T } = {},
  preFreeze?: (d: T) => void,
) {
  assert.notEmptyString(data.type, 'data requires a type', label)
  if (dataMapType[data.type]) {
    assert.failed('data type already exists', data.type, label)
  }
  let d = Object.assign({}, _default, data)

  if (preFreeze) {
    preFreeze(d)
  }

  dataMapType[d.type] = d
  dataList.push(d)
  Object.freeze(d)
}

export function genericGetDataNum<T extends { type: number }>(
  label: string,
  dataMap: { [key: number]: T },
  type: number,
) {
  let d = dataMap[type]
  assert.notNil(d, 'data does not exist', label, type)
  return d
}

export function genericRegisterDataNum<T extends { type: number }>(
  label: string,
  data: Partial<T>,
  _default: T,
  dataList: T[],
  dataMap: { [key: number]: T },
  preFreeze?: (d: T) => void,
) {
  assert.notNil(data.type, 'data requires a type', label)
  if (dataMap[data.type]) {
    assert.failed('data type already exists', data.type, label)
  }
  let d = Object.assign({}, _default, data)

  if (preFreeze) {
    preFreeze(d)
  }

  dataMap[d.type] = d // .push(d)
  dataList.push(d)
  Object.freeze(d)
}

export function findById<T extends IEntity>(id: number, objs: T[]): T | null {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].id === id) {
      return objs[i]
    }
  }
  console.log('WARN', 'findById', 'entity not found', id)
  // debugger
  return null
}

export function findByIdSafe<T extends IEntity>(
  id: number,
  objs: T[],
): T | null {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].id === id) {
      return objs[i]
    }
  }
  return null
}

export function findByPlayerNumber<T extends { playerNumber: number }>(
  playerNumber: number,
  objs: T[],
): T | null {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].playerNumber === playerNumber) {
      return objs[i]
    }
  }
  // debugger
  return null
}

export function removeDead<T extends IEntity>(
  objs: T[],
  onRemove: (obj: T) => any,
) {
  for (let i = 0; i < objs.length; i++) {
    if (objs[i].isDead) {
      onRemove(objs[i])
      objs.splice(i, 1)
      i--
    }
  }
}

export function isDeadish(obj: IDeadish | null): boolean {
  return !!(!obj || obj.isDead || obj.isDying)
}
export function isFullyAlive(obj: IDeadish | null): boolean {
  return !!(obj && !obj.isDead && obj.isDying !== true)
}
// export function removeBy(
//   objs: IEntity[],
//   filter: (obj: IEntity) => boolean,
//   onRemove: (obj: IEntity) => any,
// ) {
//   for (let i = 0; i < objs.length; i++) {
//     if (filter(objs[i])) {
//       onRemove(objs[i])
//       objs.splice(i, 1)
//       i--
//     }
//   }
// }
